import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      flexGrow: 1,
      fontFamily: 'Roboto',
      fontWeight:'bold'
    },
    a:{
      color:"white"
    }
    
  }));
  
  function Navbar({ loggedIn }) {
    const classes = useStyles();
  
    return (
      <div className={classes.root}>
        <AppBar position="static">
          <Toolbar>
            <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              samwayAI
            </Typography>
            {loggedIn ? (
              <Button color="inherit">Logout</Button>
            ) : (
              <a href='/login' ><Button className={classes.a} color="inherit">Login</Button></a>
            )}
          </Toolbar>
        </AppBar>
      </div>
    );
  }

  export default Navbar
